// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/proposal_context.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * Consumer allowlist only: no arbitrary producer JSON, evidence or private notes.
 *
 * @generated from message mono.datagateway.v1.ProposalContextSource
 */ export class ProposalContextSource extends Message {
    static fromBinary(bytes, options) {
        return new ProposalContextSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalContextSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalContextSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalContextSource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string approach = 4;
   */ _define_property(this, "approach", ""), /**
   * @generated from field: string intended_outcomes = 5;
   */ _define_property(this, "intendedOutcomes", ""), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string narrative = 7;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string limitations = 8;
   */ _define_property(this, "limitations", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalContextSource, "runtime", proto3);
_define_property(ProposalContextSource, "typeName", "mono.datagateway.v1.ProposalContextSource");
_define_property(ProposalContextSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "approach",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "intended_outcomes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalContextSection
 */ export class ProposalContextSection extends Message {
    static fromBinary(bytes, options) {
        return new ProposalContextSection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalContextSection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalContextSection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalContextSection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string wording = 2;
   */ _define_property(this, "wording", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalContextSource sources = 3;
   */ _define_property(this, "sources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalContextSection, "runtime", proto3);
_define_property(ProposalContextSection, "typeName", "mono.datagateway.v1.ProposalContextSection");
_define_property(ProposalContextSection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "wording",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sources",
            kind: "message",
            T: ProposalContextSource,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalContextContent
 */ export class ProposalContextContent extends Message {
    static fromBinary(bytes, options) {
        return new ProposalContextContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalContextContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalContextContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalContextContent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string output_id = 1;
   */ _define_property(this, "outputId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalContextSection sections = 3;
   */ _define_property(this, "sections", []), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalStaffingAssumption staffing = 4;
   */ _define_property(this, "staffing", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalContextContent, "runtime", proto3);
_define_property(ProposalContextContent, "typeName", "mono.datagateway.v1.ProposalContextContent");
_define_property(ProposalContextContent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "output_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sections",
            kind: "message",
            T: ProposalContextSection,
            repeated: true
        },
        {
            no: 4,
            name: "staffing",
            kind: "message",
            T: ProposalStaffingAssumption,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalContextAdoption
 */ export class ProposalContextAdoption extends Message {
    static fromBinary(bytes, options) {
        return new ProposalContextAdoption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalContextAdoption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalContextAdoption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalContextAdoption, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string source_kind = 4;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 5;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string original_version_id = 6;
   */ _define_property(this, "originalVersionId", ""), /**
   * @generated from field: string current_version_id = 7;
   */ _define_property(this, "currentVersionId", ""), /**
   * @generated from field: string handoff_id = 8;
   */ _define_property(this, "handoffId", ""), /**
   * @generated from field: string mode = 9;
   */ _define_property(this, "mode", ""), /**
   * @generated from field: repeated string section_keys = 10;
   */ _define_property(this, "sectionKeys", []), /**
   * @generated from field: bool changed = 11;
   */ _define_property(this, "changed", false), /**
   * @generated from field: mono.datagateway.v1.ProposalContextContent content = 12;
   */ _define_property(this, "content", void 0), /**
   * @generated from field: string created_by = 13;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalContextAdoption, "runtime", proto3);
_define_property(ProposalContextAdoption, "typeName", "mono.datagateway.v1.ProposalContextAdoption");
_define_property(ProposalContextAdoption, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "original_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "handoff_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "section_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "changed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "content",
            kind: "message",
            T: ProposalContextContent
        },
        {
            no: 13,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * Identity always comes from the authenticated forwarded principal.
 *
 * @generated from message mono.datagateway.v1.AdoptProposalContextRequest
 */ export class AdoptProposalContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdoptProposalContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptProposalContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptProposalContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptProposalContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * solution | win_theme | output | staffing; solution/staffing use the canonical Pursuit ID.
   *
   * @generated from field: string source_kind = 3;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 4;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string source_version_id = 5;
   */ _define_property(this, "sourceVersionId", ""), /**
   * Required for output: existing OUT-07 baseline, never created implicitly.
   *
   * @generated from field: string handoff_id = 6;
   */ _define_property(this, "handoffId", ""), /**
   * Explicit snapshot | live; omission is invalid.
   *
   * @generated from field: string mode = 7;
   */ _define_property(this, "mode", ""), /**
   * @generated from field: repeated string section_keys = 8;
   */ _define_property(this, "sectionKeys", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptProposalContextRequest, "runtime", proto3);
_define_property(AdoptProposalContextRequest, "typeName", "mono.datagateway.v1.AdoptProposalContextRequest");
_define_property(AdoptProposalContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "handoff_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "section_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AdoptProposalContextResponse
 */ export class AdoptProposalContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdoptProposalContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptProposalContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptProposalContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptProposalContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalContextAdoption adoption = 1;
   */ _define_property(this, "adoption", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptProposalContextResponse, "runtime", proto3);
_define_property(AdoptProposalContextResponse, "typeName", "mono.datagateway.v1.AdoptProposalContextResponse");
_define_property(AdoptProposalContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption",
            kind: "message",
            T: ProposalContextAdoption
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProposalContextRequest
 */ export class GetProposalContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string adoption_id = 2;
   */ _define_property(this, "adoptionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalContextRequest, "runtime", proto3);
_define_property(GetProposalContextRequest, "typeName", "mono.datagateway.v1.GetProposalContextRequest");
_define_property(GetProposalContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProposalContextResponse
 */ export class GetProposalContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalContextAdoption adoption = 1;
   */ _define_property(this, "adoption", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalContextResponse, "runtime", proto3);
_define_property(GetProposalContextResponse, "typeName", "mono.datagateway.v1.GetProposalContextResponse");
_define_property(GetProposalContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption",
            kind: "message",
            T: ProposalContextAdoption
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProposalContextsRequest
 */ export class ListProposalContextsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalContextsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalContextsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalContextsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalContextsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalContextsRequest, "runtime", proto3);
_define_property(ListProposalContextsRequest, "typeName", "mono.datagateway.v1.ListProposalContextsRequest");
_define_property(ListProposalContextsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProposalContextsResponse
 */ export class ListProposalContextsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalContextsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalContextsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalContextsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalContextsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalContextAdoption adoptions = 1;
   */ _define_property(this, "adoptions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalContextsResponse, "runtime", proto3);
_define_property(ListProposalContextsResponse, "typeName", "mono.datagateway.v1.ListProposalContextsResponse");
_define_property(ListProposalContextsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoptions",
            kind: "message",
            T: ProposalContextAdoption,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalContextCandidate
 */ export class ProposalContextCandidate extends Message {
    static fromBinary(bytes, options) {
        return new ProposalContextCandidate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalContextCandidate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalContextCandidate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalContextCandidate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string source_kind = 3;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 4;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string source_version_id = 5;
   */ _define_property(this, "sourceVersionId", ""), /**
   * @generated from field: string handoff_id = 6;
   */ _define_property(this, "handoffId", ""), /**
   * @generated from field: repeated string section_keys = 7;
   */ _define_property(this, "sectionKeys", []), /**
   * @generated from field: mono.datagateway.v1.ProposalContextContent content = 8;
   */ _define_property(this, "content", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalContextCandidate, "runtime", proto3);
_define_property(ProposalContextCandidate, "typeName", "mono.datagateway.v1.ProposalContextCandidate");
_define_property(ProposalContextCandidate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "handoff_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "section_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "content",
            kind: "message",
            T: ProposalContextContent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProposalContextCandidatesRequest
 */ export class ListProposalContextCandidatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalContextCandidatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalContextCandidatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalContextCandidatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalContextCandidatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalContextCandidatesRequest, "runtime", proto3);
_define_property(ListProposalContextCandidatesRequest, "typeName", "mono.datagateway.v1.ListProposalContextCandidatesRequest");
_define_property(ListProposalContextCandidatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Unauthorized choices are omitted entirely, with no hidden count or hint.
 *
 * @generated from message mono.datagateway.v1.ListProposalContextCandidatesResponse
 */ export class ListProposalContextCandidatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalContextCandidatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalContextCandidatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalContextCandidatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalContextCandidatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalContextCandidate candidates = 1;
   */ _define_property(this, "candidates", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalContextCandidatesResponse, "runtime", proto3);
_define_property(ListProposalContextCandidatesResponse, "typeName", "mono.datagateway.v1.ListProposalContextCandidatesResponse");
_define_property(ListProposalContextCandidatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidates",
            kind: "message",
            T: ProposalContextCandidate,
            repeated: true
        }
    ]));
/**
 * Early estimates are context; none imply a named person's availability.
 *
 * @generated from message mono.datagateway.v1.ProposalStaffingAssumption
 */ export class ProposalStaffingAssumption extends Message {
    static fromBinary(bytes, options) {
        return new ProposalStaffingAssumption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalStaffingAssumption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalStaffingAssumption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalStaffingAssumption, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string line_id = 1;
   */ _define_property(this, "lineId", ""), /**
   * @generated from field: string subject_kind = 2;
   */ _define_property(this, "subjectKind", ""), /**
   * @generated from field: string subject_ref = 3;
   */ _define_property(this, "subjectRef", ""), /**
   * @generated from field: string subject_label = 4;
   */ _define_property(this, "subjectLabel", ""), /**
   * @generated from field: int64 hours_centi = 5;
   */ _define_property(this, "hoursCenti", protoInt64.zero), /**
   * @generated from field: string rate_source_label = 6;
   */ _define_property(this, "rateSourceLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalStaffingAssumption, "runtime", proto3);
_define_property(ProposalStaffingAssumption, "typeName", "mono.datagateway.v1.ProposalStaffingAssumption");
_define_property(ProposalStaffingAssumption, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "line_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "subject_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "subject_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "subject_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "hours_centi",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "rate_source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalStaffingMapping
 */ export class ProposalStaffingMapping extends Message {
    static fromBinary(bytes, options) {
        return new ProposalStaffingMapping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalStaffingMapping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalStaffingMapping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalStaffingMapping, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string line_id = 1;
   */ _define_property(this, "lineId", ""), /**
   * @generated from field: string lcat_id = 2;
   */ _define_property(this, "lcatId", ""), /**
   * @generated from field: int64 hours_centi = 3;
   */ _define_property(this, "hoursCenti", protoInt64.zero), /**
   * @generated from field: string provider = 4;
   */ _define_property(this, "provider", ""), /**
   * @generated from field: string period = 5;
   */ _define_property(this, "period", ""), /**
   * @generated from field: string task = 6;
   */ _define_property(this, "task", ""), /**
   * @generated from field: string pricing_structure = 7;
   */ _define_property(this, "pricingStructure", ""), /**
   * @generated from field: string evidence_gap = 8;
   */ _define_property(this, "evidenceGap", ""), /**
   * @generated from field: string availability_gap = 9;
   */ _define_property(this, "availabilityGap", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalStaffingMapping, "runtime", proto3);
_define_property(ProposalStaffingMapping, "typeName", "mono.datagateway.v1.ProposalStaffingMapping");
_define_property(ProposalStaffingMapping, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "line_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "hours_centi",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "provider",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "task",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pricing_structure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "evidence_gap",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "availability_gap",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalContextWording
 */ export class ProposalContextWording extends Message {
    static fromBinary(bytes, options) {
        return new ProposalContextWording().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalContextWording().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalContextWording().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalContextWording, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_key = 1;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: string wording = 2;
   */ _define_property(this, "wording", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalContextWording, "runtime", proto3);
_define_property(ProposalContextWording, "typeName", "mono.datagateway.v1.ProposalContextWording");
_define_property(ProposalContextWording, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "wording",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalContextDecision
 */ export class ProposalContextDecision extends Message {
    static fromBinary(bytes, options) {
        return new ProposalContextDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalContextDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalContextDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalContextDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string parent_id = 2;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: string action = 3;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string basis = 4;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string accepted_version_id = 5;
   */ _define_property(this, "acceptedVersionId", ""), /**
   * @generated from field: string reviewed_version_id = 6;
   */ _define_property(this, "reviewedVersionId", ""), /**
   * @generated from field: mono.datagateway.v1.ProposalContextContent content = 7;
   */ _define_property(this, "content", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalStaffingMapping mappings = 8;
   */ _define_property(this, "mappings", []), /**
   * @generated from field: string actor_id = 9;
   */ _define_property(this, "actorId", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 10;
   */ _define_property(this, "decidedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalContextDecision, "runtime", proto3);
_define_property(ProposalContextDecision, "typeName", "mono.datagateway.v1.ProposalContextDecision");
_define_property(ProposalContextDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "accepted_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reviewed_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "content",
            kind: "message",
            T: ProposalContextContent
        },
        {
            no: 8,
            name: "mappings",
            kind: "message",
            T: ProposalStaffingMapping,
            repeated: true
        },
        {
            no: 9,
            name: "actor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * Each field is an allowlisted solicitation value, with row identity and revision.
 *
 * @generated from message mono.datagateway.v1.ProposalStaffingRequirement
 */ export class ProposalStaffingRequirement extends Message {
    static fromBinary(bytes, options) {
        return new ProposalStaffingRequirement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalStaffingRequirement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalStaffingRequirement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalStaffingRequirement, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string version = 3;
   */ _define_property(this, "version", ""), /**
   * @generated from field: map<string, string> fields = 4;
   */ _define_property(this, "fields", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalStaffingRequirement, "runtime", proto3);
_define_property(ProposalStaffingRequirement, "typeName", "mono.datagateway.v1.ProposalStaffingRequirement");
_define_property(ProposalStaffingRequirement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fields",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalContextReview
 */ export class ProposalContextReview extends Message {
    static fromBinary(bytes, options) {
        return new ProposalContextReview().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalContextReview().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalContextReview().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalContextReview, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalContextAdoption adoption = 1;
   */ _define_property(this, "adoption", void 0), /**
   * @generated from field: mono.datagateway.v1.ProposalContextContent upstream = 2;
   */ _define_property(this, "upstream", void 0), /**
   * @generated from field: mono.datagateway.v1.ProposalContextDecision accepted = 3;
   */ _define_property(this, "accepted", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalContextDecision history = 4;
   */ _define_property(this, "history", []), /**
   * @generated from field: bool pending = 5;
   */ _define_property(this, "pending", false), /**
   * @generated from field: repeated string changed_fields = 6;
   */ _define_property(this, "changedFields", []), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalStaffingRequirement requirements = 7;
   */ _define_property(this, "requirements", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalContextReview, "runtime", proto3);
_define_property(ProposalContextReview, "typeName", "mono.datagateway.v1.ProposalContextReview");
_define_property(ProposalContextReview, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption",
            kind: "message",
            T: ProposalContextAdoption
        },
        {
            no: 2,
            name: "upstream",
            kind: "message",
            T: ProposalContextContent
        },
        {
            no: 3,
            name: "accepted",
            kind: "message",
            T: ProposalContextDecision
        },
        {
            no: 4,
            name: "history",
            kind: "message",
            T: ProposalContextDecision,
            repeated: true
        },
        {
            no: 5,
            name: "pending",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "changed_fields",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "requirements",
            kind: "message",
            T: ProposalStaffingRequirement,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProposalContextReviewRequest
 */ export class GetProposalContextReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalContextReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalContextReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalContextReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalContextReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string adoption_id = 2;
   */ _define_property(this, "adoptionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalContextReviewRequest, "runtime", proto3);
_define_property(GetProposalContextReviewRequest, "typeName", "mono.datagateway.v1.GetProposalContextReviewRequest");
_define_property(GetProposalContextReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProposalContextReviewResponse
 */ export class GetProposalContextReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalContextReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalContextReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalContextReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalContextReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalContextReview review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalContextReviewResponse, "runtime", proto3);
_define_property(GetProposalContextReviewResponse, "typeName", "mono.datagateway.v1.GetProposalContextReviewResponse");
_define_property(GetProposalContextReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ProposalContextReview
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideProposalContextRequest
 */ export class DecideProposalContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideProposalContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideProposalContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideProposalContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideProposalContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string adoption_id = 2;
   */ _define_property(this, "adoptionId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * Empty for first acceptance; otherwise the exact latest decision ID.
   *
   * @generated from field: string expected_decision_id = 4;
   */ _define_property(this, "expectedDecisionId", ""), /**
   * @generated from field: string expected_upstream_version_id = 5;
   */ _define_property(this, "expectedUpstreamVersionId", ""), /**
   * accept_new | keep_accepted | edit
   *
   * @generated from field: string action = 6;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string basis = 7;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalContextWording wording = 8;
   */ _define_property(this, "wording", []), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalStaffingMapping mappings = 9;
   */ _define_property(this, "mappings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideProposalContextRequest, "runtime", proto3);
_define_property(DecideProposalContextRequest, "typeName", "mono.datagateway.v1.DecideProposalContextRequest");
_define_property(DecideProposalContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_decision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_upstream_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "wording",
            kind: "message",
            T: ProposalContextWording,
            repeated: true
        },
        {
            no: 9,
            name: "mappings",
            kind: "message",
            T: ProposalStaffingMapping,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideProposalContextResponse
 */ export class DecideProposalContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideProposalContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideProposalContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideProposalContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideProposalContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalContextReview review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideProposalContextResponse, "runtime", proto3);
_define_property(DecideProposalContextResponse, "typeName", "mono.datagateway.v1.DecideProposalContextResponse");
_define_property(DecideProposalContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ProposalContextReview
        }
    ]));
